import { render, staticRenderFns } from "./write.vue?vue&type=template&id=06f2d1d0&scoped=true&"
import script from "./write.js?vue&type=script&lang=js&"
export * from "./write.js?vue&type=script&lang=js&"
import style0 from "./write.css?vue&type=style&index=0&id=06f2d1d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2d1d0",
  null
  
)

export default component.exports